import { useState, useEffect } from 'react';
import { Box, Container, ThemeProvider } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NavBar from '../../layout/NavBar';
import { UserApi } from '../../../services/api';
import { darkTheme } from '../../../theme/darkTheme';
import ResetPasswordForm from './components/resetpassword/ResetPasswordForm';

function ResetPassword() {
  const [, setShowNotification] = useState(false);
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setMessage({ type: "error", text: 'Token nicht gefunden' });
    }
  }, [token]);

  const handleSubmit = async (newPassword, confirmPassword) => {
    if (!newPassword || !confirmPassword) {
      setMessage({ type: "error", text: 'Bitte beide Passwortfelder ausfüllen' });
      return;
    }

    if (newPassword.length < 6) {
      setMessage({ type: "error", text: 'Passwort muss mindestens 6 Zeichen lang sein' });
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage({ type: "error", text: 'Passwörter stimmen nicht überein' });
      return;
    }

    setLoading(true);

    try {
      await UserApi.resetPassword(token, newPassword);
      setMessage({ type: "success", text: 'Passwort erfolgreich zurückgesetzt! Du wirst zum Login weitergeleitet...' });
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      if (err.response?.data?.error) {
        setMessage({ type: "error", text: err.response.data.error });
      } else {
        setMessage({ type: "error", text: "Ein Fehler ist aufgetreten. Bitte versuche es später erneut." });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
        <NavBar />
        <Container maxWidth="sm">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 'calc(100vh - 64px)',
              py: 3,
            }}
          >
            <ResetPasswordForm
              loading={loading}
              message={message}
              onNotificationClose={() => {
                setShowNotification(true);
                setMessage({ type: "", text: "" });
              }}
              onSubmit={handleSubmit}
              onBackToLogin={() => navigate('/login')}
            />
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default ResetPassword;
